export const ElevatorEnergized = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      stroke="#363BC4"
      strokeMiterlimit="10"
      d="M8.835 7.634h.996m-2.997 0h1m2.998 0h1m-2.499 1.64V18m-6 0h12M4.33 6h10.003v12H4.33zm2.002 3.274h6V18h-6z"
    />
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.548 10h-1.691c-.053 0-.08 0-.103.007a.2.2 0 0 0-.055.029.3.3 0 0 0-.053.075l-1.234 2.1c-.056.095-.084.143-.078.182a.12.12 0 0 0 .061.084c.038.023.101.023.227.023h1.824l-.882 2.5 3.584-3.161c.12-.107.181-.16.185-.206a.12.12 0 0 0-.052-.103c-.04-.03-.128-.03-.302-.03h-2.092z"
    />
  </svg>
);
